import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum OpportunityBoardReportFields {
  seatStartDate = 'seatStartDate',
  seatEndDate = 'seatEndDate',
  teamId = 'teamId',
  teamName = 'teamName',
  fullName = 'fullName',
  personId = 'personId',
  firstName = 'firstName',
  lastName = 'lastName',
  suffix = 'suffix',
  prefix = 'prefix',
  email = 'email',
  currentStatus = 'currentStatus',
  position = 'position',
  dateExpressedInterest = 'dateExpressedInterest',
  applicationId = 'applicationId',
  opportunityBoardName = 'opportunityBoardName'
}

export const OpportunityBoardReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(OpportunityBoardReportFields.currentStatus, '', 'Current Status'),
  new ItemPickerModel(OpportunityBoardReportFields.seatStartDate, '', 'Start Date'),
  new ItemPickerModel(OpportunityBoardReportFields.seatEndDate, '', 'End Date'),
  new ItemPickerModel(OpportunityBoardReportFields.teamName, '', 'Team Name'),
  new ItemPickerModel(OpportunityBoardReportFields.fullName, '', 'Full Name'),
  new ItemPickerModel(OpportunityBoardReportFields.firstName, '', 'First Name'),
  new ItemPickerModel(OpportunityBoardReportFields.lastName, '', 'Last Name'),
  new ItemPickerModel(OpportunityBoardReportFields.suffix, '', 'Suffix'),
  new ItemPickerModel(OpportunityBoardReportFields.prefix, '', 'Prefix'),
  new ItemPickerModel(OpportunityBoardReportFields.email, '', 'Email'),
  new ItemPickerModel(OpportunityBoardReportFields.position, '', 'Position'),
  new ItemPickerModel(
    OpportunityBoardReportFields.dateExpressedInterest,
    '',
    'Date Expressed Interest'
  ),
  new ItemPickerModel(OpportunityBoardReportFields.opportunityBoardName, '', 'Opportunity Board')
];
